const MedicAtentionsGroup = () => /* webpackChunkName: "EmptyRouterView" */ import("@/views/medic_hosp/medic_atention/medicAtentionsGroup.vue");
const EmptyRouterView = () => /* webpackChunkName: "EmptyRouterView" */ import("../views/mental_health_no_medic/EmptyRouterView.vue");
const MentalMedicHealthHome = () => /* webpackChunkName: "Home" */ import("../views/mental_health_no_medic/Home.vue");
const MentalHealthArchive = () =>
  /* webpackChunkName: "MentalHealthArchive" */ import("../views/mental_health_no_medic/mental_health_archive/MentalHealthArchive.vue");
const ProfesionalManteiner = () => /* webpackChunkName: "ProfesionalManteiner" */ import("../views/mental_health_no_medic/ProfesionalManteiner.vue");
const MedicAtention = () => /* webpackChunkName: "MedicAtentions" */ import("../views/mental_health_no_medic/medic_atention/medicAtentions.vue");
const RegisterAtentions = () => /* webpackChunkName: "RegisterAtentions" */ import("../views/mental_health_no_medic/registerAtention/registerAtentions.vue");
const Document = () => /* webpackChunkName: "Document" */ import("@/views/general/Document.vue");

export const routes = [
  {
    path: "/mental_health_no_medic",
    component: EmptyRouterView,
    children: [
      {
        path: "",
        name: "professionalNoMedicHome",
        component: MentalMedicHealthHome,
      },
      {
        path: "atencionMedica",
        name: "professionalMentalHealthNoMedicAtention",
        component: MedicAtention,
      },
      {
        path: "cartola-salud-mental",
        name: "professionalMentalHealthNoarchiveMentalHealth",
        component: MentalHealthArchive,
      },
      {
        path: "mantenedor-profesionales",
        name: "professionalMentalHealthNoprofesionalManteinerMentalHealth",
        component: ProfesionalManteiner,
      },
      {
        path: "registro-antecedentes",
        name: "professionalMentalHealthNoRegisterAtentions",
        component: RegisterAtentions,
      },
      {
        path: "documentacion",
        name: "professionalNoMedicDocumentation",
        component: Document,
      },
      {
        path: "registro-antecedentes",
        name: "professionalNoMedicmedicHospRegisterAtentions",
        component: RegisterAtentions,
      },
      {
        path: "atencionMedicaGrupo",
        name: "MedicAtentionGroup",
        component: MedicAtentionsGroup,
      },
    ],
  },
];
